const LOCALES = [{ locale: 'es', match: /es/ }]

export default LOCALES
